export default __webpack_public_path__ + "static/media/my-maor-new-logo.9b1bafc4.png";